export { default as AdvetisementSlider } from "./AdvetisementSlider";
